import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import {
    TrackingUtils,
    URLUtils,
    withPageContext,
    SessionStorageUtils,
    ABUtils,
    Config,
    WMPUtils,
    MetricUtils,
    ErrorBoundary
} from '../../utils';
import { isCurrentSearchPopulated, isStopoverMode } from '../../redux/currentSearch/selectors';
import { getFilteredPreviousSearches } from '../../redux/previousSearch/selectors';
import { getGeoLocatedSearch } from '../../redux/geoLocations/selectors';
import { getGeoLocationByIP, getGeoLocations } from '../../redux/geoLocations/actions';
import {
    setAllSearch,
    resetSearch,
    updateSegment,
    setHotel,
    setTripType,
    addSegment,
    setCabinClass,
    updateSearcherConfig,
    setAirlineFilter,
} from '../../redux/currentSearch/actions';
import { setActiveProduct } from '../../redux/activeProduct/actions';
import { EntryPoint, TripType, TripTypeShort, SearchProp, FlightClass, searcherConfigs } from '../../models';

export class FlightsManager extends PureComponent {
    state = {
        shouldPrefillFieldsFromWMP: false
    }

    componentDidMount() {
        const {
            previousSearches,
            currentSearch,
            setAllSearch,
            isCurrentSearchPopulated,
            getGeoLocationByIP,
            setActiveProduct,
            setHotel,
            getGeoLocations,
            rootDataAttr,
            activeProduct = EntryPoint.FLIGHTS,
        } = this.props;
        const { isReactGeolocationByIp } = ABUtils.getABs();
        const urlParams = URLUtils.getHomeHashParams();

        if (WMPUtils.hasCustomCitiesList() || WMPUtils.hasPrefilledCities()) {
            getGeoLocations(rootDataAttr);
        }

        this.handleInitialSearchAndTracking({
            urlParams,
            isCurrentSearchPopulated,
            previousSearches,
            setAllSearch,
            rootDataAttr,
            currentSearch,
        });

        if (isReactGeolocationByIp && previousSearches.length === 0 && (!urlParams || !urlParams.from)) {
            getGeoLocationByIP();
        }

        window.onhashchange = (e) => {
            const { oldURL } = e;
            const { resetSearch } = this.props;
            const isComingFromInspirational = !!oldURL.match(/inspirational/);
            if (isComingFromInspirational) {
                resetSearch();
            }
        };
        setHotel(false);
        setActiveProduct(activeProduct);
    }

    // eslint-disable-next-line complexity
    componentDidUpdate(prevProps) {
        const {
            previousSearches,
            currentSearch,
            isFetchingGeoLocations,
            isCurrentSearchPopulated,
            setAllSearch,
            updateSegment,
            geoLocationByIP,
            isFetchingGeoLocationByIP,
            isStopoverMode,
            rootDataAttr,
            updateSearcherConfig,
            setAirlineFilter,
        } = this.props;
        const { airlinefiltername, airlinefilteriata, stopover } = rootDataAttr;
        if (!isFetchingGeoLocations && prevProps.isFetchingGeoLocations) {
            this.initialiseSearchWithDataFromGeoLocations();
            SessionStorageUtils.setValue('isAccommodationPostBooking', false);
            this.stopMetrics();
        }

        if (!isCurrentSearchPopulated && previousSearches.length > 0) {
            this.trackSearchLoadsFilled();
            setAllSearch(this.getValidFlightFromPreviousSearches(previousSearches));
        }

        if (!isFetchingGeoLocationByIP && prevProps.isFetchingGeoLocationByIP && !isEmpty(geoLocationByIP)) {
            updateSegment({ origin: geoLocationByIP }, currentSearch.segments[0].id);
        }

        if (isStopoverMode && !prevProps.isStopoverMode) {
            updateSearcherConfig(WMPUtils.getStopoverConfig(stopover));
            this.setWMPCities();
            if (airlinefiltername && airlinefilteriata) {
                setAirlineFilter({
                    airlineName: airlinefiltername,
                    airlineIata: airlinefilteriata,
                    enabled: true
                });
            }
        } else if (!isStopoverMode && prevProps.isStopoverMode) {
            updateSearcherConfig(searcherConfigs.default);
        }
    }

    setWMPParameterConfiguration = () => {
        const defaultNumberOfSegmentsInMultipleTrip = 2;
        const { getGeoLocations, setTripType, setCabinClass, addSegment, rootDataAttr } = this.props;
        const { triptype, numbersegments, flightclass } = rootDataAttr;
        if (flightclass && FlightClass[flightclass.toUpperCase()]) {
            setCabinClass(flightclass.toUpperCase());
        }
        if (triptype && TripTypeShort[triptype]) {
            setTripType(TripTypeShort[triptype]);
            if (TripTypeShort[triptype] === TripType.MULTIPLE && numbersegments) {
                const extraLegs = parseInt(numbersegments, 10) - defaultNumberOfSegmentsInMultipleTrip;
                for (let index = extraLegs; index > 0; index--) {
                    addSegment({ id: Date.now() + index });
                }
            }
        }
        if (WMPUtils.hasPrefilledCities() && !WMPUtils.hasCustomCitiesList()) {
            getGeoLocations(rootDataAttr);
        }
    };

    setWMPCities = () => {
        const {
            currentSearch,
            updateSegment,
            geoLocations,
            rootDataAttr,
        } = this.props;
        const { from, to } = rootDataAttr;
        if ( from || to) {
            updateSegment({ origin: geoLocations.geoLocations[from], destination: geoLocations.geoLocations[to] }, currentSearch.segments[0].id);
        } else {
            const numberOfSegments = currentSearch.segments.length;
            for (let i=0; i<numberOfSegments; i++) {
                const from = `from${i}`;
                const to = `to${i}`;
                const origin = rootDataAttr[from] ? geoLocations.geoLocations[rootDataAttr[from]] : null;
                const destination = rootDataAttr[to] ? geoLocations.geoLocations[rootDataAttr[to]] : null;
                updateSegment({ origin: origin, destination: destination }, currentSearch.segments[i].id);
            }
        }
    }

    initialiseSearchWithDataFromGeoLocations = () => {
        const { isCurrentSearchPopulated, geoLocatedSearch, setAllSearch } = this.props;
        const urlParams = URLUtils.getHomeHashParams();
        if (this.state.shouldPrefillFieldsFromWMP) {
            this.trackSearchLoadsFilled();
            this.setWMPCities();
        } else if (!isEmpty(urlParams) || !isCurrentSearchPopulated) {
            this.trackSearchLoadsFilled();
            setAllSearch(geoLocatedSearch);
        }
    };

    trackSearchLoadsFilled = () => {
        const { trackEvent } = this.props;
        const action = TrackingUtils.ACTION.FLIGHTS;
        trackEvent({ action, label: 'searcher_loads_filled' });
    };


    getPaxCount = (pax) => {
        if (!pax) return 1;
        return (pax.adults || 0) + (pax.kids || 0) + (pax.infants || 0);
    };

    getTripTypeLabel = (tripType) => {
        const TRIP_TYPE_LABEL = {
            [TripType.ROUND_TRIP]: 'RT',
            [TripType.ONE_WAY]: 'OW',
            [TripType.MULTIPLE]: 'MD',
        };
        return TRIP_TYPE_LABEL[tripType] || 'RT';
    };

    trackOnloadPrefilled = (searchData) => {
        const { trackEvent, currentSearch } = this.props;
        const source = searchData ?? currentSearch;
        const segment = source?.segments?.[0];
        const orig = segment?.origin?.iata || 'na';
        const dest = segment?.destination?.iata || 'na';
        const dep = segment?.date ? 1 : 0;
        const returnSegment = source?.tripType === TripType.ROUND_TRIP ? source?.segments?.[1] : null;
        const ar = returnSegment?.date ? 1 : 0;
        const pax = this.getPaxCount(source?.pax);
        const tt = this.getTripTypeLabel(source?.tripType);
        const lan = (Config.get('lang') || '').slice(0, 2).toUpperCase();
        trackEvent({
            action: TrackingUtils.ACTION.FLIGHTS,
            label: `home_onload_prefilled:orig:${orig}_dest:${dest}_dep:${dep}_ar:${ar}_pax:${pax}_tt:${tt}_lan:${lan}`,
        });
    };

    getValidFlightFromPreviousSearches = (previousSearches) => {
        const search = previousSearches[0];
        search.separateStay = { enabled: false };
        search.rooms = [];
        search.isHotel = false;
        return search;
    };

    handleInitialSearchAndTracking({
        urlParams,
        isCurrentSearchPopulated,
        previousSearches,
        setAllSearch,
        rootDataAttr,
        currentSearch,
    }) {
        if (isEmpty(urlParams)) {
            if (!isCurrentSearchPopulated) {
                if (previousSearches.length > 0) {
                    this.trackSearchLoadsFilled();
                    const validSearch = this.getValidFlightFromPreviousSearches(previousSearches);
                    setAllSearch(validSearch);
                    this.trackOnloadPrefilled(validSearch);
                } else {
                    this.setState({ shouldPrefillFieldsFromWMP: WMPUtils.hasPrefilledCities() });
                    this.setWMPParameterConfiguration();
                    const { triptype } = rootDataAttr;
                    const rootDataTripType = triptype && TripTypeShort[triptype] ? TripTypeShort[triptype] : undefined;
                    this.trackOnloadPrefilled(rootDataTripType ? { ...currentSearch, tripType: rootDataTripType } : undefined);
                }
            } else {
                this.trackOnloadPrefilled();
            }
            SessionStorageUtils.setValue('isAccommodationPostBooking', false);
            this.stopMetrics();
        } else {
            this.trackOnloadPrefilled();
        }
    }

    stopMetrics() {
        const isWMP = Config.get('isWMP');
        const metricFramework = `LOAD_REACT${isWMP ? '_WMP' : ''}`;
        MetricUtils.trackStop(metricFramework);
    }

    render() {
        const { render, currentSearch, isCurrentSearchPopulated } = this.props;
        return (
            <ErrorBoundary>
                {render(currentSearch, isCurrentSearchPopulated)}
            </ErrorBoundary>
        );
    }
}

FlightsManager.propTypes = {
    render: PropTypes.func.isRequired,
    currentSearch: SearchProp.isRequired,
    previousSearches: PropTypes.arrayOf(SearchProp),
    resetSearch: PropTypes.func.isRequired,
    setActiveProduct: PropTypes.func.isRequired,
    setAllSearch: PropTypes.func.isRequired,
    setHotel: PropTypes.func.isRequired,
    getGeoLocationByIP: PropTypes.func,
    updateSegment: PropTypes.func,
    trackEvent: PropTypes.func.isRequired,
    geoLocatedSearch: SearchProp.isRequired,
    isFetchingGeoLocations: PropTypes.bool,
    geoLocationByIP: PropTypes.object,
    isFetchingGeoLocationByIP: PropTypes.bool,
    isCurrentSearchPopulated: PropTypes.bool,
    rootDataAttr: PropTypes.object,
    setTripType: PropTypes.func,
    setCabinClass: PropTypes.func,
    addSegment: PropTypes.func,
    getGeoLocations: PropTypes.func,
    updateSearcherConfig: PropTypes.func,
    isStopoverMode: PropTypes.bool.isRequired,
    setAirlineFilter: PropTypes.func,
};

FlightsManager.defaultProps = {
    previousSearches: [],
    isFetchingGeoLocations: false,
    isCurrentSearchPopulated: false,
    getGeoLocationByIP: ()=>{},
    updateSegment: ()=>{},
    geoLocationByIP: {},
    isFetchingGeoLocationByIP: false,
    rootDataAttr: {},
    setTripType: ()=>{},
    setCabinClass: ()=>{},
    addSegment: ()=>{},
    getGeoLocations: ()=>{},
    geoLocations: {},
    updateSearcherConfig: ()=>{},
    isStopoverMode: false,
    setAirlineFilter: ()=>{},
};

const mapStateToProps = (state) => ({
    currentSearch: state.currentSearch,
    previousSearches: getFilteredPreviousSearches(state),
    geoLocatedSearch: getGeoLocatedSearch({
        geoLocations: state.geoLocations.geoLocations,
        allowCitiesWithoutIata: false,
        activeProduct: state.activeProduct.activeProduct,
    }),
    isFetchingGeoLocations: state.geoLocations.isFetching,
    geoLocationByIP: state.geoLocations.geoLocationByIP,
    isFetchingGeoLocationByIP: state.geoLocations.isFetchingGeoLocationByIP,
    isCurrentSearchPopulated: isCurrentSearchPopulated(state),
    geoLocations: state.geoLocations,
    isStopoverMode: isStopoverMode(state),
    activeProduct: state.activeProduct.activeProduct,
});

export const ConnectedFlightsManager = connect(mapStateToProps, {
    resetSearch,
    setActiveProduct,
    setAllSearch,
    setHotel,
    getGeoLocationByIP,
    updateSegment,
    setTripType,
    setCabinClass,
    addSegment,
    getGeoLocations,
    updateSearcherConfig,
    setAirlineFilter,
})(withPageContext(FlightsManager));
